<template>
  <div class="flex-1 test-form">
    <h2>Анкета участника</h2>
    <div class="test-form__content align-item-center flex">
      <div class="test-form__registration">
        <a-form layout="vertical" :model="form" @finish="clickOnBtn">

          <div class="testing-form">
            <div class="personal-row">
                <a-form-item label="Фамилия" class="input-form-item" name="last_name" required>
                  <a-input v-model:value="form.last_name" />
                </a-form-item>

                <a-form-item label="Имя" class="input-form-item"
                             name="first_name"
                             :rules="[{ required: true, message: 'Введите имя' }]"
                >
                  <a-input name="first_name" v-model:value="form.first_name" />
                </a-form-item>

                <a-form-item label="Отчество" class="input-form-item" name="patronymic" required>
                  <a-input v-model:value="form.patronymic" />
                </a-form-item>

                <a-form-item label="Почта" class="input-form-item" name="email"
                             :rules="[
                          { required: true, message: 'Введите почту' },
                          { type: 'email', message: 'Неверный формат' }]">
                  <a-input name="email" v-model:value="form.email" placeholder="Введите почту"/>
                </a-form-item>

                <city-input @changeCity="(value) => form.city_id = value" :currentCity="profile?.city ?? null"/>

                <div class="sub-row">
                  <a-form-item label="Пол" class="input-form-item" name="sex" required >
                    <a-select
                        v-model:value="form.sex"
                        :placeholder="'Пол'"
                        style="width: 100%;"
                        show-arrow
                    >
                      <a-select-option :key="'m'" value="male">
                        Мужчина
                      </a-select-option>
                      <a-select-option :key="'f'" value="female">
                        Женщина
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="Год рождения" class="input-form-item" name="year" required style="width: 100%">
                    <a-input-number v-model:value="form.year" placeholder="Год рождения"></a-input-number>
                  </a-form-item>
                </div>
              </div>

            <div class="professional-row">
              <a-form-item label="Профессия" class="input-form-item" name="profession_id" required>
                <a-select
                    v-model:value="form.profession_id"
                    :placeholder="'Профессия'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                    show-arrow
                >
                  <a-select-option v-for="item in professionOptions" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Отрасль" class="input-form-item" name="industry_id" required>
                <a-select
                    v-model:value="form.industry_id"
                    :placeholder="'Отрасль'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                    show-arrow
                >
                  <a-select-option v-for="item in industriesOptions" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Название должности" class="input-form-item" name="job_title" required>
                <a-input v-model:value="form.job_title" />
              </a-form-item>

              <a-form-item label="Уровень должности" class="input-form-item" name="position_id" required>
                <a-select
                    v-model:value="form.position_id"
                    :placeholder="'Уровень должности'"
                    style="width: 100%;"
                    :not-found-content="'Нет данных'"
                    show-arrow
                >
                  <a-select-option v-for="item in positionOptions" :key="item.id" :value="item.id">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <a-checkbox v-model:checked="approval">
            Я даю свое согласие на обработку персональных данных
          </a-checkbox>
          <div class="additional-info">
            <p>
              Заполняя данную анкету, вы выражаете своё согласие на сбор, обработку, использование, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, обезличивание, блокирование, удаление своих персональных данных, указанных в настоящей анкете, в целях обработки статистической информации.
            </p>
            <a class="link" href="https://way2wei.ru/document/privacy_policy" target="_blank">
              Политика в отношении обработки персональных данных
            </a>
          </div>
        </a-form>
      </div>
      <div class="test-form__instruction">
        <div class="test-form__instruction-title">
          Пожалуйста, уточните информацию о себе. Эти данные необходимы, чтобы сравнить ваши результаты с нормами вашей отрасли и сформировать корректный профиль.
        </div>
      </div>
    </div>

    <div class="test-form__btn flex justify-content-between">
      <a-button @click="backToInstruction" class="secondary-button">
        Назад
      </a-button>

      <a-button form="testForm" html-type="submit" class="primary-button" :disabled="!approval" @click="clickOnBtn">
        Начать тест
      </a-button>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "@vue/reactivity";
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import CustomRadio from "@/components/Forms/Fields/CustomRadio.vue";
import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
import CustomCheckbox from "@/components/Forms/Fields/CustomCheckbox.vue";
import { computed, onBeforeMount, onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import useAjaxSelect from "@/mixins/useAjaxSelect";
import useErrors from "@/mixins/useErrors";
import standartError from "@/mixins/standartError";
import { notify } from "@kyvg/vue3-notification";
import useProfileForm from "@/mixins/useProfileForm";
import CityInput from "@/components/Forms/Fields/CityInput.vue";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  PaperClipOutlined, PlusOutlined,
  UploadOutlined
} from "@ant-design/icons-vue";
import {message} from "ant-design-vue";
export default {
  components: {
    PlusOutlined,
    UploadOutlined,
    CloseOutlined,
    CloseCircleOutlined,
    CheckCircleOutlined,
    PaperClipOutlined,
    CityInput, CustomInput, CustomRadio, CustomSelect2, CustomCheckbox },
  setup(props, context) {
    const store = useStore(),
      route = useRoute(),
      { setErrors, clearCustomErrors } = useErrors(),
      { setForm } = useProfileForm();
    const { cityAjax } = useAjaxSelect();
    let professionOptions = ref([]),
        industriesOptions =  ref([]),
      positionOptions = ref([]);
    const positionList = computed(() => store.state.test.positionList),
      professionList = computed(() => store.state.test.professionList),
      industriesList =  computed(() => store.state.test.industriesList),
      profile = computed(() => store.state.profile.profile);
    let approval = ref(false);
    const form = reactive({
      last_name: null,
      first_name: null,
      patronymic: null,
      email: null,
      age: null,
      sex: null,
      profession_id: null,
      industry_id: null,
      position_id: null,
      job_title: null,
      city: null,
      city_id: null,
      year: null,
    });

    onBeforeMount(() => {
      store.dispatch("test/getPositionList").then(() => {
        positionOptions.value = positionList.value.map((position) => {
          return { id: position.id, text: position.text };
        });
      });
      store.dispatch("test/getProfessionList").then(() => {
        professionOptions.value = professionList.value.map((profession) => {
          return { id: profession.id, text: profession.text };
        });
      });
      store.dispatch("test/getIndustriesList").then(() => {
          industriesOptions.value = industriesList.value.map((industry) => {
              return { id: industry.id, text: industry.text };
          });
      });
      store.dispatch("profile/getProfile").then(() => {
        setForm(profile.value, form);
      });
    });

    const clickOnBtn = (event) => {
      form.age = calculateAge();

      event.preventDefault();
      if (
        !approval.value ||
        !form.last_name ||
        !form.first_name ||
        !form.patronymic ||
        !form.sex ||
        !form.job_title ||
        !form.profession_id ||
        !form.position_id ||
        !form.city_id ||
        !form.industry_id ||
        !form.year ||
        !form.age
      ) {
        message.error('Не все поля заполнены');
        return;
      }

      store
        .dispatch("test/sendTestForm", { code: route.params.code, form })
        .then(() => {
          context.emit("clickOnBtn");
        })
        .catch(standartError(setErrors, clearCustomErrors));
    };
    const backToInstruction = () => {
      context.emit("backToInstruction");
    };

    const calculateAge = () => {
      const yearNow = new Date().getFullYear();
      if (!Number.isFinite(form.year) || form.year < 1900 || form.year > yearNow) return null;
      return yearNow - form.year;
    }
    return {
      professionOptions,
      industriesOptions,
      positionOptions,
      form,
      clickOnBtn,
      backToInstruction,
      approval,
      positionList,
      professionList,
      profile,
      cityAjax,
    };
  },
};
</script>

<style lang="scss" scoped>
.test-form {
  text-align: left;
  height: 100%;
  width: 100%;
  display: flex;
  padding: 10px 40px;
  flex-direction: column;
  justify-content: center;
  position: relative;
  border: 2px solid transparent;

  &__city {
    margin: 20px -5px;
    padding-left: 15px;
    font-weight: 400;

    span {
      font-weight: 300;
    }
  }

  // .test-form__registration

  &__registration {
    flex: 1 1;
  }

  // .test-form__radios

  &__radios {
    .form-group:not(:last-child) {
      margin-right: 1rem;
    }
  }

  // .test-form__instruction

  &__instruction {
    flex: 0 1 50%;
    margin-left: 30px;
    margin-top: -5%;
  }

  // .test-form__instruction-title

  &__instruction-title {
    font-size: 14px;
  }

  &__btn {
    padding: 3px 5px;
    .btn {
      padding: 11px 25px;
    }
  }

  &__radios {
    margin-top: 20px;
  }

  &__personal {
    margin-top: 20px;
    justify-content: center;
  }

  @media (max-width: 1500px) {
    &__registration {
      flex: 1 1;
    }
  }

  @media (max-width: 1507px) {
    &__content {
      flex-direction: column-reverse;
    }
    &__instruction {
      margin-left: 0;
      padding-top: 10px;
      margin-top: 0;
    }
    &__registration {
      width: 100%;
      padding: 20px 0;
    }
  }
  @media (max-width: 974px) {
    &__registartion {
      padding: 0 0 10px 0;
    }
    &__radios {
      margin-top: 25px;
    }
    padding: 20px;
  }
}

.error-form {
  border: 2px solid red;
}

.link {
  color: var(--main-green);
}

.additional-info {
  padding: 0 5px;
  margin-bottom: 25px;
  font-size: 14px;
  color: var(--grey-text);
  font-weight: 400;

  p {
    margin-bottom: 0;
  }
}

:deep(.ant-form-item-label) {
  padding: 0;
}

.testing-form {
  max-width: 700px;
  display: flex;
  column-gap: 15px;

  .professional-row, .personal-row {
    width: 50%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 10px;

    .professional-row, .personal-row {
      width: 100%;
    }
  }
}

.sub-row {
  display: flex;
  column-gap: 10px;

  .ant-form-item {
    width: 50%;
  }
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}
</style>
